import { Alert, Stack, TextField } from "@mui/material";
import VerifiedUserRoundedIcon from "@mui/icons-material/VerifiedUserRounded";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { MobileNumberField } from "../../../components/common/form/MobileNumberField";
import { PublicFormButton, PublicFormCard } from "../../../components/common/form/PublicFormCard";
import { APIS } from "../../../modules/common/api/apis";
import { post } from "../../../modules/common/shared/AxiosAPI";
import { Student } from "../../../modules/common/shared/types";
import { getApiErrorMessage } from "../../../modules/common/shared/util/ApiErrorUtil";
import { isValidMobileNo } from "../../../modules/common/shared/util/FormValidationUtil";

const INVALID_DETAILS = "Invalid details. Kindly contact the school.";

export const AdmissionVerify = () => {
  const navigate = useNavigate();

  const [studentName, setStudentName] = useState("");
  const [phoneNo, setPhoneNo] = useState<string | null>(null);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [isVerifying, setIsVerifying] = useState(false);

  const validateAdmission = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (isVerifying) return;
    setErrorMessage(null);

    if (!phoneNo || !isValidMobileNo(phoneNo)) {
      setErrorMessage("Please enter a valid 10-digit mobile number.");
      return;
    }

    setIsVerifying(true);
    post(APIS.VERIFY_ADMISSION, null, { sName: studentName.trim().toUpperCase(), gPhone: phoneNo })
      .then((res) => {
        if (res.status === 200) {
          const dbStd: Student = res.data;
          navigate("/admission/create", { state: { student: dbStd } });
        } else {
          setErrorMessage(INVALID_DETAILS);
          setIsVerifying(false);
        }
      })
      .catch((err) => {
        setErrorMessage(getApiErrorMessage(err, INVALID_DETAILS));
        setIsVerifying(false);
      });
  };

  return (
    <PublicFormCard
      icon={<VerifiedUserRoundedIcon />}
      title="Verify admission details"
      subtitle="Enter the student's name and the mobile number you gave when submitting the enquiry."
    >
      <Stack component="form" spacing={2} onSubmit={validateAdmission}>
        {errorMessage && (
          <Alert severity="error" role="alert" onClose={() => setErrorMessage(null)}>
            {errorMessage}
          </Alert>
        )}
        <TextField
          fullWidth
          label="Student Name"
          name="sName"
          size="small"
          required
          autoFocus
          value={studentName}
          onChange={(e) => {
            setStudentName(e.target.value);
            if (errorMessage) setErrorMessage(null);
          }}
          sx={{ "& input": { textTransform: "uppercase" } }}
        />
        <MobileNumberField
          label="Mobile No"
          name="gPhone"
          value={phoneNo}
          onChange={(val) => {
            setPhoneNo(val);
            if (errorMessage) setErrorMessage(null);
          }}
          required
          fullWidth
        />
        <PublicFormButton type="submit" loading={isVerifying}>
          Verify
        </PublicFormButton>
      </Stack>
    </PublicFormCard>
  );
};
